export type PressEffect = 'glow' | 'ring' | 'none';

export const glowEffect = {
  durationMs: 600,
  /**
   * MUI-style ripple: a circle starts at the exact click point and expands
   * outward to cover the button, fading as it grows. The parent button MUST
   * have `overflow: hidden` for the wave to be clipped to the button's shape.
   *
   * `clickX` / `clickY` are coordinates relative to the button's bounding box.
   * `diameter` is the final ripple size — typically `max(width, height) * 2`
   * so the wave fully covers the button regardless of click position.
   */
  createNode(color: string, clickX: number, clickY: number, diameter: number): HTMLSpanElement {
    const span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.style.cssText = `
      position: absolute;
      top: ${clickY - diameter / 2}px;
      left: ${clickX - diameter / 2}px;
      width: ${diameter}px;
      height: ${diameter}px;
      border-radius: 50%;
      transform: scale(0);
      background: ${color};
      opacity: 0.35;
      pointer-events: none;
      animation: nula-glow-pulse ${glowEffect.durationMs}ms ease-out forwards;
    `;
    return span;
  },
} as const;

export const ringEffect = {
  durationMs: 450,
  createNode(color: string): HTMLSpanElement {
    const span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.style.cssText = `
      position: absolute;
      inset: -1px;
      border-radius: inherit;
      border: 2px solid ${color};
      pointer-events: none;
      animation: nula-ring-pulse ${ringEffect.durationMs}ms ease-out forwards;
    `;
    return span;
  },
} as const;
